import { render, staticRenderFns } from "./AddClinicDocument.vue?vue&type=template&id=6b545fc9"
import script from "./AddClinicDocument.vue?vue&type=script&lang=js"
export * from "./AddClinicDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports